import { render, staticRenderFns } from "./Loader-Modal.vue?vue&type=template&id=389a1b30&"
import script from "./Loader-Modal.vue?vue&type=script&lang=js&"
export * from "./Loader-Modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports